import React, { useContext, useEffect, useState } from "react";
import { Grid, Button, Dropdown, Segment, Message } from "semantic-ui-react";
import { toast } from "react-toastify";
import { config } from "../../contexts/UrlContext";
import axios, { AxiosResponse } from "axios";
import AuthContext from "../../contexts/AuthContext";
import { getRequest } from "../../services/axiosService";


type themeProps = {
    selectedTheme: string,
    onThemeChange: any,
}

function ThemeDropdown({ selectedTheme, onThemeChange, }: themeProps) {

    const { auth } = useContext(AuthContext);


    const [themeSelected, setThemeSelected] = useState(selectedTheme);
    const [themeOptions, setThemeOptions] = useState([]);

    useEffect(() => {
        async function getData() {
            await getThemes();

            if (selectedTheme)
                setThemeSelected(selectedTheme);
        }
        getData();
    }, [])

    const getThemes = async () => {
        try {
            let response: AxiosResponse = await getRequest(auth, `/Theme/GetAllThemes`);

            let data = response.data;

            if (data !== null) {
                setThemeOptions(data);
            }
        } catch (e) {
            console.log(e);
            toast.error(`Unable to get CM2WebShare Themes. Please see logs for more info`);
        }
        
    }

    const onDropdownChange = (event: any, result: any) => {
        setThemeSelected(result.value);
        onThemeChange(result.value);
    }

    return (
        <>
            <div className="header gray headerStyleGray" style={{ marginLeft: '0px' }}>CHOOSE THEME</div>
            <Dropdown id="theme-dropdown" placeholder='Select Theme' style={{ backgroundColor: "#e5e5e5" }} fluid search selection options={themeOptions} onChange={onDropdownChange} value={themeSelected} />
               
         </>       
       
    )
}

export default ThemeDropdown;
